import { UI } from '../ui';

export let menu = {

	//selectors
	headerSelector : '#header-top',
    menuSelector : '#page-menu',
    navSelector : '.nav--menu',
    buttonSelector : '.do-toggle-page-menu',

    //classes
    openClass : 'menu--open',
    hasSubmenuClass : 'item--has-submenu',

    bind : function() {

        let button = document.querySelector(this.buttonSelector);

        //menu is divided into separate Nodes due to tab layout, so we need to select all of them and later iterate with forEach
        let navs = document.querySelectorAll(this.navSelector);

		/* 
		 *	1. bind menu UI button
		 */
		if(button === null) return;

		button.addEventListener('click', (event) => {
			this.toggleMenu();
			event.preventDefault();
        });      
        
		/* 
		 *	2. bind navigation links with different logic regarding submenu based
		 *	on current viewport width
		 */
		if(navs === null) return;

        let navLinks = [];

        // remember: multiple nav menus due to tabs layout
        navs.forEach(nav => {
            navLinks = [...navLinks, ...nav.querySelectorAll('a') ];
        });

		navLinks.forEach( (item) => {

            let li = item.parentNode;
			
			if( li.classList.contains(this.hasSubmenuClass) ) {

				//bind event to <a>
				item.addEventListener('click', (event) => {

                    //different behavior for mobile and desktop:

					if( UI.windowWidth <= 960 ) {
						this.toggleSubmenu(li);						
                        event.preventDefault();
                    }
				});				

			}				

		});        

    },

	/**
	 * toggle page menu
	 */
    toggleMenu : function() {

        let menu = document.querySelector(this.menuSelector);
        let button = document.querySelector(this.buttonSelector);

        menu.classList.toggle(this.openClass);
        button.classList.toggle(this.openClass);

    },

	toggleSubmenu : function (el) {

		let parent = el.parentNode;
        let openClass = this.openClass;

		//select siblings based on current <li>
		let siblings = Array.prototype.filter.call(parent.children, function(child){
			return child !== el;
		});			

		//remove open class from siblings
		siblings.forEach( function(sibling) {
			sibling.classList.remove(openClass);
		});

        // toggle open class
        el.classList.toggle(openClass);
	

	},    



}